export default "__VITE_ASSET__BjjUHagISQHtPWYmu3KuwQ__ 48w, __VITE_ASSET__gOpBNSELCNdnM_yZlyA5OQ__ 96w";